import { render, staticRenderFns } from "./CardConfigMensageria.vue?vue&type=template&id=4223dcf8"
import script from "./CardConfigMensageria.vue?vue&type=script&lang=js"
export * from "./CardConfigMensageria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4223dcf8')) {
      api.createRecord('4223dcf8', component.options)
    } else {
      api.reload('4223dcf8', component.options)
    }
    module.hot.accept("./CardConfigMensageria.vue?vue&type=template&id=4223dcf8", function () {
      api.rerender('4223dcf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardConfigMensageria.vue"
export default component.exports